import { LDSDivider, LDSHeading } from "@resmed/lumina-design-system";
import { getDateLabel } from "../../utils/DateHelper";

export interface DateDividerProps {
  timestamp: string;
}

const DateDivider = ({ timestamp }: DateDividerProps) => (
  <LDSDivider layout="horizontal" align="center">
    <LDSHeading
      size="h5"
      className="lds-typography-xs-medium lds-text-textcolor-weak lds-px-3 lds-bg-white lds-relative lds-z-[1]"
    >
      {getDateLabel(timestamp)}
    </LDSHeading>
  </LDSDivider>
);

export default DateDivider;
